import React, { useState, useEffect, useCallback } from 'react';
import { useRequest, useModel } from 'umi';
import styles from '@/pages/camp/components/css/detailCSS.less';
import { Tooltip, Avatar, Alert } from 'antd';
import { RankingVO } from '@/types/camp/details/detailsType';
import { StudyInfoType } from '@/types/camp/study/studentBaseInfoType';
import { getRanking } from '@/utils/requests/camp/requests_details';
import { ExclamationCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import ranking1Svg from '@/static/images/ranking1.svg';
import ranking2Svg from '@/static/images/ranking2.svg';
import ranking3Svg from '@/static/images/ranking3.svg';
import cx from 'classnames';
import { daysUntil } from '@/pages/camp/util/indexUtil';
import { BatchInfoVO } from '@/types/camp/campIndex/indexTypes';
import NoData from '@/components/noData';

interface Props {
  studentBaseInfo: BatchInfoVO | null;
  leftHeight?: number;
}
const StudyRanking: React.FC<Props> = ({ studentBaseInfo, leftHeight }) => {
  const [dataList, setDataList] = React.useState<RankingVO[]>([]);
  const { initialState } = useModel('@@initialState');

  // 领取奖励接口
  const { run: postReceiveRewardRequest } = useRequest(
    () => {
      return getRanking(studentBaseInfo?.id || '', studentBaseInfo?.cardCampId || '');
    },
    {
      manual: true,
      onSuccess: (res) => {
        setDataList(res);
      },
    },
  );
  useEffect(() => {
    postReceiveRewardRequest();
  }, []);

  const rankingIndex = (index: number) => {
    switch (index) {
      case 1:
        return <img src={ranking1Svg} />;
      case 2:
        return <img src={ranking2Svg} />;
      case 3:
        return <img src={ranking3Svg} />;

      default:
        return index;
    }
  };

  return (
    <div className="com_cmap_card_box" style={{ overflow: 'hidden', height: '100%' }}>
      <div className="com_card_title16 flex_1" style={{ marginBottom: 16 }}>
        <span>学分排行榜</span>
        <Tooltip
          placement="top"
          title="按照获得学分从高到低排序，学分相同时按照完成打卡时间先后排序。"
        >
          <QuestionCircleOutlined className="col808 f14" style={{ marginLeft: 4, marginTop: 2 }} />
        </Tooltip>
      </div>

      {dataList.length > 0 ? (
        <div
          className={styles.camp_ranking_box_admin}
          style={{ height: leftHeight ? leftHeight : 580 }}
        >
          {dataList.map((item, index) => (
            <div className={cx(styles.camp_ranking_item, 'flex_1')} key={index}>
              <span className={styles.ranking_index}>{rankingIndex(item.ranking)}</span>
              <a href={`https://bbs.fanruan.com/u/${item.createdBy}`} target="blank">
                <Avatar
                  size={40}
                  src={`https://bbs.fanruan.com/uc_server/avatar.php?uid=${item.createdBy}&amp;size=small`}
                />
              </a>
              <div className={styles.user_info}>
                <div className="f14 flex_1">
                  <div className="hide_txt" style={{ width: 'auto', maxWidth: 130 }}>
                    {item.username}
                  </div>
                </div>
                <div className="flex_3 f12 col808" style={{ marginTop: 2, paddingRight: 10 }}>
                  <div>
                    进度 {item.countSuccessNode}/{item.countAllNode}
                  </div>
                  <div>学分 {item.campScore}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <NoData name="暂无数据" />
      )}
    </div>
  );
};
export default StudyRanking;
